import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
export function ScrollManager() {
  const {
    pathname,
    hash
  } = useLocation();
  useEffect(() => {
    if (!hash) window.scrollTo({
      top: 0
    });
  }, [pathname, hash]);
  return null;
}